//React
import { FunctionComponent, useEffect, useState } from "react";

//App Hooks
import {
	useAppDispatch,
	useAppSelector,
} from "../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectIsMobile } from "../../system/redux/selectors/select-is-mobile";
import { setFacetModalOpen } from "../redux/slices/facet-slice";

//Components
import AreaNewHomeCount from "../../area-info/components/area-new-home-count";
import FacetLink from "./facet-link";
import SortLink from "../../results/components/sorting/sort-link";
import SortMenu from "../../results/components/sorting/sort-menu";
import RfiButton from "../../system/components/rfi/rfi-button";

interface FacetContainerProps {}

const FacetContainer: FunctionComponent<FacetContainerProps> = (props) => {
	const dispatch = useAppDispatch();

	const isMobile = useAppSelector(selectIsMobile);

	//Use Effects
	//Detecting if we should show the map icon in the facet container or not, this will show up when
	//you scroll down and the map is not wholly visible.
	useEffect(() => {
		const updateMapIcon = () => {
			if (isMobile) {
				const scrolledY = window.scrollY;
				const mapIcon = document.querySelector(".mapLinkContainer");

				if (mapIcon && scrolledY > 350) {
					mapIcon.classList.add("scrolled-down");
				} else {
					mapIcon.classList.remove("scrolled-down");
				}
			}
		};

		window.addEventListener("scroll", updateMapIcon);

		// Cleanup the event listener when the component unmounts
		return () => {
			window.removeEventListener("scroll", updateMapIcon);
		};
	}, []);

	//JSX
	return (
		<>
			<div className="community-set__filters">
				{!isMobile && <AreaNewHomeCount />}
				<div className="mapLinkContainer">
					<button
						className="community-set__map-button"
						type="button"
						aria-label="Show map"
						onClick={() => {
							const downArrow = document.getElementsByClassName(
								"area-info-anchor-down",
							);
							const downArrowButton = document
								.getElementsByClassName("area-info-anchor-down")
								.item(0) as HTMLScriptElement;
							if (downArrow.length > 0) {
								downArrowButton.click();
							}
							window.scrollTo(0, 0);
						}}
					>
						<span className="map-icon">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.9 15">
								<path d="M5.45 1.39a3.93 3.93 0 0 1 3.93 3.93c0 1.49-2.13 5.05-3.93 7.65-1.8-2.59-3.93-6.15-3.93-7.65a3.93 3.93 0 0 1 3.93-3.93m0-1.18C2.62.21.34 2.5.34 5.33S5.45 15 5.45 15s5.11-6.85 5.11-9.67S8.27.21 5.45.21z" />
								<circle cx="5.45" cy="5.34" r="1.65" />
							</svg>
						</span>
						<span>Map</span>
					</button>
				</div>
				<div className="resultsContainer">
					<button
						className="community-set__filter-button community-set__filter-button--filter js-filter"
						type="button"
						//id="open-filters"
						//	tabIndex="0"
						aria-label="Open filters modal"
						onClick={() => {
							dispatch(setFacetModalOpen(true));
						}}
					>
						<span className="filter-icon">
							<svg
								aria-hidden="true"
								role="img"
								focusable="false"
								xmlns="http://www.w3.org/2000/svg"
								x="0"
								y="0"
								viewBox="0 0 15 15"
							>
								<path
									fill="currentColor"
									d="M11.8 10.4c0-.3-.1-.7-.4-.9-.2-.2-.6-.4-.9-.4-.3 0-.7.1-.9.4-.3.2-.4.5-.4.9v.8H.3v1.5h8.9v.8c0 .3.1.7.4.9.2.2.6.4.9.4.7 0 1.3-.6 1.3-1.3v-.8h3v-1.5h-3v-.8z"
								></path>
								<path
									fill="currentColor"
									d="M5.8 6c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3v.8h-3v1.5h3V9c0 .7.6 1.3 1.3 1.3.3 0 .7-.1.9-.4.3-.2.4-.5.4-.9v-.8h8.9V6.7H5.8V6z"
								></path>
								<path
									fill="currentColor"
									d="M11.8 2.3v-.7c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3v.8H.3v1.5h8.9v.8c0 .3.1.7.4.9.2.2.6.4.9.4.3 0 .7-.1.9-.4.2-.2.4-.6.4-.9v-.8h3V2.3h-3z"
								></path>
							</svg>
							<FacetLink />
						</span>
						<span>Filter</span>
					</button>

					<SortMenu />
					<RfiButton />
				</div>
			</div>
		</>
	);
};

export default FacetContainer;
